<!--
  loading.vue

  This component have following props:

  @prop title {String} - String to override default "Loading" message.
  @prop titleScale {Number} @optional - Scale of how title size should be. Default to be 4. (<h2> size)
-->

<template>
  <figure class="loading">
    <div>
      <img src="/assets/public/images/bullet-icon-colours.svg" alt="loading-icon" />
    </div>
    <figcaption>
      <p class="title" :style="{ 'font-size': fontSize }">{{ title }}</p>
      <slot></slot>
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    title: {
      type: String,
      default: 'Loading…',
    },
    titleScale: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    fontSize() {
      const baseScale = 1.25;
      // const scale = baseScale ** this.titleScale;
      // If title scale is 0, return 1rem
      let fontSize = '1rem';

      if (this.titleScale > 0) {
        // If title scale is larger than 0
        fontSize = `${1 * baseScale ** this.titleScale}rem`;
      } else if (this.titleScale < 0) {
        // If title scale is less than 0
        fontSize = `${1 * (1 / baseScale) ** Math.abs(this.titleScale)}rem`;
      }

      return fontSize;
    },
  },
};
</script>

<style lang="scss">
@import '@general/styles/_constants.scss';
@import '@general/styles/_mixins.scss';

.loading {
  text-align: center;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  perspective: 800px;
  position: relative;
  margin: 0;
  overflow: hidden;

  figcaption {
    margin-top: 40px;

    .title {
      font-weight: $BOLD;
      margin-bottom: 2rem;
    }
  }

  div {
    width: vutter(1);
    height: vutter(1);
    position: relative;
    animation: spinner 3s cubic-bezier(0.7, 0, 0.3, 1) infinite;
    transform-style: preserve-3d;
    margin-bottom: vutter(0.5);
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    min-height: 100%;
    min-width: 100%;
    transform: translate3d(-50%, -50%, 120px) rotateX(20deg);
  }
}

@keyframes spinner {
  from {
    transform: rotateY(0deg) translateY(0) rotateX(-20deg);
  }

  to {
    transform: rotateY(360deg) translateY(0) rotateX(-20deg);
  }
}
</style>
